"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Layout = _interopRequireDefault(require("./Layout"));
var _default = exports["default"] = _Layout["default"];